import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const CONTRACTVARIABLE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('variableName', 'Entity.ContractVariable.VariableName')
    .required()
    .maxLength(25)
    .build(),
  FieldBuilder
    .text('code', 'Entity.ContractVariable.Code')
    .required()
    .maxLength(10)
    .build(),
];

export const CONTRACTVARIABLE_CONFIG = {
  entityName: 'ContractVariable',
  localizationKey: 'Controlling::Entity.ContractVariable',
  fields: CONTRACTVARIABLE_FIELDS,
  permission: 'ControllingContract.ContractVariables',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
